let backgroundTele = `
<g transform="translate(0.000000,300.000000) scale(0.029297,-0.044379)"
fill="#000000" stroke="none">
<path d="M1120 4015 l0 -1695 2880 0 2880 0 0 1695 0 1695 -2880 0 -2880 0 0
-1695z m5740 5 l0 -1680 -2857 2 -2858 3 -3 1665 c-1 916 0 1671 3 1678 3 9
585 12 2860 12 l2855 0 0 -1680z"/>
<path d="M1280 4015 l0 -1535 2720 0 2720 0 0 1535 0 1535 -2720 0 -2720 0 0
-1535z m5425 0 l0 -1520 -2704 -3 -2705 -2 24 25 23 25 2656 0 2655 0 25 -22
c22 -20 23 -20 8 -2 -16 19 -17 108 -17 1499 0 1393 1 1480 18 1499 17 21 17
21 -4 4 -19 -17 -162 -18 -2681 -18 -2648 0 -2660 0 -2678 20 l-18 20 2699 -2
2699 -3 0 -1520z m-5365 2 c0 -1354 -1 -1472 -17 -1489 -9 -10 -20 -18 -25
-18 -4 0 -8 680 -8 1512 l0 1511 25 -23 25 -23 0 -1470z m5308 1 l2 -1468
-2650 0 -2650 0 0 1463 c0 805 3 1467 7 1470 3 4 1195 6 2647 5 l2641 -3 3
-1467z"/>
<path d="M8612 4018 l3 -1693 163 -3 162 -2 0 94 c0 104 3 115 149 486 l61
155 0 960 0 960 -76 198 c-42 108 -79 196 -81 193 -2 -2 28 -85 66 -185 l71
-181 0 -984 0 -983 -91 -234 c-50 -129 -93 -236 -95 -238 -2 -2 -4 652 -3
1455 l1 1459 23 -50 c31 -66 31 -52 0 31 -20 54 -25 85 -25 160 l0 94 -165 0
-165 0 2 -1692z m148 -3 l0 -1685 -65 0 -65 0 0 1685 0 1685 65 0 65 0 0
-1685z m168 3 l-3 -1683 -72 -3 -73 -3 0 1686 0 1685 75 0 75 0 -2 -1682z"/>
<path d="M2120 1264 l-265 -103 -368 -1 -367 0 2 -162 3 -163 2875 0 2875 0 3
163 2 162 -365 0 -366 0 -130 51 c-72 27 -133 48 -135 46 -2 -2 46 -22 106
-46 61 -23 110 -44 110 -47 0 -2 -946 -4 -2102 -3 -1907 1 -2100 2 -2068 16
35 15 171 68 369 144 l104 39 1598 0 1599 0 132 -50 c72 -28 132 -49 134 -47
2 2 -55 27 -126 55 l-131 52 -1612 -1 -1612 -1 -265 -104z m4748 -186 l-3 -73
-2865 0 -2865 0 -3 59 c-2 32 -1 65 2 72 5 12 462 14 2871 14 l2866 0 -3 -72z
m0 -155 l-3 -68 -2865 0 -2865 0 -3 54 c-2 29 -1 60 2 67 5 12 455 14 2871 14
l2866 0 -3 -67z"/>
</g>
`

export default [
  {
    title: "Diagnostic",
    childs: [
      {
        label: "Réception",
        type: "select",
        valueKeyname: "reception",
        values: [
          {label: "TNT Terrestre", value: "tnt_terrestre"},
          {label: "TNT câble", value: "tnt_cable"},
          {label: "Satellite", value: "sattelite"}
        ],
        required: true
      },
      {
        label: "ADSL CÂBLE",
        type: "select",
        valueKeyname: "adsl_cable",
        values: [
          {label: "Free", value: "free"},
          {label: "Numericable", value: "numericable"},
          {label: "Orange", value: "orange"},
          {label: "SFR", value: "sfr"},
          {label: "Bouygues", value: "bouygues"},
          {label: "Autre", value: "autre"},
        ],
        required: true
      },
      {
        label: "Satellite",
        type: "select",
        valueKeyname: "satellite",
        values: [
          {label: "Canalsat", value: "canalsat"},
          {label: "Fransat", value: "fransat"},
          {label: "Autre", value: "autre"},
        ],
        required: true
      },
      {
        label: "Console",
        type: "select",
        valueKeyname: "controle",
        values: [
          {label: "Wii", value: "wii"},
          {label: "Xbox", value: "xbox"},
          {label: "Sony", value: "sony"},
          {label: "Autre", value: "autre"},
        ],
        required: true
      },
      {
        label: "DVD/Bluray",
        type: "select",
        valueKeyname: "dvd_bluray",
        values: [
          {label: "Samsung", value: "samsung"},
          {label: "Sony", value: "sony"},
          {label: "LG", value: "lg"},
          {label: "Toshiba", value: "toshiba"},
          {label: "Autre", value: "autre"},
        ],
        required: true
      },
      {
        label: "Home cinema",
        type: "select",
        valueKeyname: "home_cinema",
        values: [
          {label: "Samsung", value: "samsung"},
          {label: "Autre", value: "autre"},
        ],
        required: true
      },
      {
        label: "Internet",
        type: "select",
        valueKeyname: "internet",
        values: [
          {label: "Câble Ethernet", value: "samsung"},
          {label: "Sony", value: "sony"},
          {label: "LG", value: "lg"},
          {label: "Toshiba", value: "toshiba"},
          {label: "Autre", value: "autre"},
        ],
        required: true
      },
      {
        label: "Défaut non reproduit",
        type: "select",
        valueKeyname: "defaut_non_reproduit",
        values: [
          {label: "Problème constant", value: "pb_constant"},
          {label: "Problème intermittent", value: "probleme_intermittent"},
          {label: "Exterieur (environnement)", value: "exterieur_environnement"},
        ],
        required: true
      },
      {
        label: "Description de la panne constatée",
        placeholder: "Description..",
        valueKeyname: "description_panne",
        type: "textarea",
        required: true
      }
    ]
  },
  {
    title: "Réparation",
    childs: [
      {
        label: "Mise à jour Soft Main / Sub Micom",
        valueKeyname: "maj",
        type: "text",
        required: true,
      },
      {
        label: "Mise à jour complète faite ?",
        valueKeyname: "maj_complete",
        type: "select",
        values: [
          {label: "Oui", value: "oui"},
          {label: "Non", value: "non"},
        ],
        required: true
      },
      {
        label: "Chocs et rayures constatés avant enlèvement",
        valueKeyname: "dessin_choc",
        type: "draw",
        background: backgroundTele
      },
    ]
  },
  {
    title: "Contrôle final",
    childs: [
      {
        label: "",
        valueKeyname: "controle_final",
        type: "checkboxs",
        values: [
          {label: "Mise sous tension", value: "mise_sous_tension"},
          {label: "Remise en place des réglages client", value: "reglage_client"},
          {label: "Remise en place des périphériques externes", value: "mise_en_place_periph_externes"},
          {label: "Connexion internet", value: "connexion_internet"},
          {label: "Visualisation de contenu externe", value: "visualisation_contenu_externe"},
          {label: "Nettoyage", value: "nettoyage"},
          {label: "Reprogrammation ports HDMI", value: "reprogrammation_ports_hdmi"},
          {label: "Firmware", value: "firmware"},
          {label: "Condition de réception", value: "condition_reception"},
          {label: "Vérification et sécurisation connecteurs périphériques", value: "verif_connecteurs_peripheriques"},
        ],
        required: true
      },
    ]
  },
  {
    title: "Observations",
    childs: [
      {
        label: "",
        valueKeyname: "observation",
        type: "textarea",
        required: true
      },
    ],
  }
]


// export default [
//   {
//     title: "Diagnostic",
//     childs: [
//       {
//         label: "Réception",
//         type: "select",
//         valueKeyname: "reception",
//         values: [
//           {label: "TNT Terrestre", value: "tnt_terrestre"},
//           {label: "TNT câble", value: "tnt_cable"},
//           {label: "Satellite", value: "sattelite"}
//         ],
//         required: true
//       },
//     ]
//   }
// ]
